// 把后端返回的日期/时间按中国时区（东八区 UTC+8）格式化显示。
//
// 背景：wgx 后端 mysql2 默认把 DATE/DATETIME 读成 JS Date 对象，res.json()
// 会序列化为带 Z 的 UTC 时间。例如服务器本地 2026-08-27 00:00:00（东八区）
// 经 Date 处理后内部是 UTC 2026-08-26 16:00:00Z，前端若直接显示就是「16:00」
// 且日期错一天。这里统一还原为东八区显示。
//
// 入参支持：
//  - 纯日期 'YYYY-MM-DD'      → 无时区歧义，原样返回
//  - ISO 8601（含 T 或 Z）     → 按 UTC 解析后 +8h 显示东八区
//  - 'YYYY-MM-DD HH:mm:ss'     → 视为已是目标时区字符串，原样返回
export function formatCST(value) {
  if (value === null || value === undefined || value === '') return '-'
  const s = String(value).trim()
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s
  if (s.includes('T') || s.includes('Z')) {
    const d = new Date(s)
    if (!isNaN(d.getTime())) return toCST(d)
  }
  return s
}

// 用固定东八区偏移计算，不依赖浏览器本地时区，保证任何环境都显示中国时间
function toCST(d) {
  const offset = 8 * 3600 * 1000
  const cst = new Date(d.getTime() + offset)
  const p = (n) => String(n).padStart(2, '0')
  return (
    cst.getUTCFullYear() +
    '-' + p(cst.getUTCMonth() + 1) +
    '-' + p(cst.getUTCDate()) +
    ' ' + p(cst.getUTCHours()) +
    ':' + p(cst.getUTCMinutes()) +
    ':' + p(cst.getUTCSeconds())
  )
}



// WEBPACK FOOTER //
// ./src/admin/utils/format.js